export default {
  tag: 'Test',
  tag_tooltip: 'Restaurant de test: funcționează complet, nu este facturat niciodată.',
  card: {
    title: 'Restaurant de test',
    description:
      'Marchează un restaurant ca restaurant de test pentru a încerca tipărirea, e-mailurile, comenzile și integrările în producție. Funcționează ca orice alt restaurant și nu este facturat niciodată. E-mailurile și SMS-urile pentru clienți despre comenzile sale încep cu [TEST].',
    payments_note:
      'Plățile la restaurantul de test sunt reale și sunt plătite ca la oricare altul. Rambursează tu însuți comenzile de test. Suntem notificați când vânzările sale lunare depășesc pragul de testare.',
    designated_on: 'Marcat ca test pe {{date}}',
    open_shop: 'Deschide magazinul',
    remove: 'Elimină marcajul de Test',
    select_placeholder: 'Alege un restaurant',
    mark: 'Marchează ca restaurant de test',
    no_restaurants: 'Nu ai încă niciun restaurant de marcat.',
    load_error: 'Restaurantul tău de test nu a putut fi încărcat.',
  },
  remove_confirm: {
    title: 'Elimini marcajul de Test de la {{name}}?',
    description_live:
      'Facturarea pentru acest restaurant reîncepe, iar acesta trece imediat offline. Relansează-l din Setări comenzi → Metode de comandă → Comenzi live, unde alegi planul său.',
    description_stays_live:
      'Acest restaurant rămâne activ și este tratat ca oricare dintre celelalte restaurante ale dumneavoastră începând de acum.',
    description_offline:
      'Facturarea pentru acest restaurant reîncepe odată ce devine live. Planul său este ales când îl lansezi.',
    confirm: 'Elimină marcajul de Test',
  },
  toasts: {
    designated: '{{name}} este acum restaurantul tău de test. Nu este facturat.',
    designate_error: 'Restaurantul nu a putut fi marcat ca test. Te rugăm să încerci din nou.',
    removed: '{{name}} nu mai este restaurantul tău de test.',
    removed_offline: '{{name}} nu mai este restaurantul tău de test și este acum offline.',
    remove_error: 'Marcajul de Test nu a putut fi eliminat. Te rugăm să încerci din nou.',
  },
};
